import { render, staticRenderFns } from "./lkuItemReceipt.vue?vue&type=template&id=4a67f271"
import script from "./lkuItemReceipt.vue?vue&type=script&lang=js"
export * from "./lkuItemReceipt.vue?vue&type=script&lang=js"
import style0 from "./lkuItemReceipt.vue?vue&type=style&index=0&id=4a67f271&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports